/**
 * Initializes live confirm-password match feedback on the temp-password
 * change page: shows #password-confirmation-error while the confirmation
 * field differs from #password-field, hides it once they match. Also keeps
 * the form's submit button disabled until both fields are filled and match,
 * per the redesigned page's Cancel/Save button pair.
 */
export const initPasswordConfirmationMatch = () => {
  const field = /** @type {HTMLInputElement} */ (
    document.getElementById('password-field')
  );
  const confirmField = /** @type {HTMLInputElement} */ (
    document.getElementById('password-confirmation-field')
  );
  const errorMessage = document.getElementById('password-confirmation-error');
  if (!field || !confirmField || !errorMessage) return;

  const submitButton = /** @type {HTMLInputElement | null} */ (
    field.closest('form')?.querySelector('.devise-form-wrapper__sign-in-button')
  );

  const validate = () => {
    const mismatch = confirmField.value.length > 0 && confirmField.value !== field.value;
    errorMessage.style.display = mismatch ? 'block' : 'none';
    confirmField.classList.toggle('devise-form-wrapper__input--error', mismatch);

    if (submitButton) {
      submitButton.disabled = mismatch || field.value === '' || confirmField.value === '';
    }
  };

  field.addEventListener('input', validate);
  confirmField.addEventListener('input', validate);
  validate();
};
